import * as actionTypes from './actionTypes';
import * as interfaces from './interfaces';

interface I_GroupDetailReq {
    GroupID: string;
}
interface I_GroupAllToursReq {
    NormGroupID: string;
}

interface I_GroupAllCalendarReq {
    NormGroupID: string;
    GoDateStart?: string;
    GoDateEnd?: string;
    TourID?: string;
}

interface I_TodayMoreReq {
    NormGroupID: string;
    GroupID?: string;
    GoDate: string;
}
interface I_PriceInfoReq {
    GroupID: string;
}

interface I_SkiReq {
    GroupID: string;
}

interface I_StationInfoReq {
    GroupID: string;
}
interface I_FlightInfoReq {
    NormGroupID: string;
    GroupID: string;
    GoDate: string;
}

export const setGroup = (payload: any) => ({
    type: actionTypes.SET_GROUP,
    payload,
});

export const setGroupDetailSync = (payload: any) => ({
    type: actionTypes.SET_GROUPDETAIL_SYNC,
    payload,
});

// export const setGroupDetail = (payload: I_GroupDetailReq) => ({
//     type: actionTypes.SET_GROUPDETAIL,
//     payload,
// });

// export const setGroupDetailSUCCESS = (payload: any) => ({
//     type: actionTypes.SET_GROUPDETAIL_SUCCESS,
//     payload,
// });

export const setPricesInfo = (payload: I_PriceInfoReq) => ({
    type: actionTypes.SET_PRICESINFO,
    payload,
});

export const setPricesInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_PRICESINFO_SUCCESS,
    payload,
});

export const setStationInfo = (payload: I_StationInfoReq) => ({
    type: actionTypes.SET_STATIONINFO,
    payload,
});

export const setStationInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_STATIONINFO_SUCCESS,
    payload,
});

export const setFlightInfo = (payload: I_FlightInfoReq) => ({
    type: actionTypes.SET_FLIGHTINFO,
    payload,
});

export const setFlightInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_FLIGHTINFO_SUCCESS,
    payload,
});

export const setCurrentTourID = (payload: any) => ({
    type: actionTypes.SET_CURRENTTOURID,
    payload,
});

// export type I_GroupDetailAction = ReturnType<typeof setGroupDetail>;
export type I_PricesInfoAction = ReturnType<typeof setPricesInfo>;
export type I_StationInfoAction = ReturnType<typeof setStationInfo>;
export type I_FlightInfoAction = ReturnType<typeof setFlightInfo>;
